function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
global.getAnonymousId = function() {
  var anonymousId = null;
  if(window && window.analytics && window.analytics.user){
    anonymousId = window.analytics.user().anonymousId();
  }
  return anonymousId;
}

global.getUrlParameter = function(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

global.pageUrl = function() {
  var url = new URL(window.location.href);
  return url.host + url.pathname;
}

global.hostUrl = window.location.protocol + "//" + window.location.host  + '/';

global.getGaId = function() {
  let cookieGa = getCookie('_ga');
  if (!!cookieGa) {
    cookieGa = cookieGa.split(".");
    cookieGa.shift();
    cookieGa.shift();
    cookieGa = cookieGa.join('.');
    return cookieGa;
  } else {
    return 'None';
  }
}

global.getHash = function() {
  return new Date().getTime() + '.' + Math.random().toString(36).substring(5);
}


global.getDidomiCookieConsent = function() {
  let rslt = "None";
  const didomiToken = getCookie("didomi_token");

  if ( !isBase64(didomiToken) )  { return rslt; }

  let didomiTokenDecoded = atob(didomiToken);

  if ( !isJsonString(didomiTokenDecoded) )   { return rslt; }

  didomiTokenDecoded = JSON.parse(didomiTokenDecoded);

  if ( !didomiTokenDecoded.vendors )   { return rslt; }

  const hasPurposesEnabled = !!didomiTokenDecoded.purposes && !!didomiTokenDecoded.purposes.enabled || false;
  const hasPurposesDisabled = !!didomiTokenDecoded.purposes && !!didomiTokenDecoded.purposes.disabled || false;

  if ( !hasPurposesEnabled ) {
    rslt = "Denied: all";
  } else if ( !hasPurposesDisabled ) {
    rslt =  "Accepted: all";
  } else {
    rslt = "Accepted: " + didomiTokenDecoded.purposes.enabled;
  }
  return rslt;
}

global.isBase64 = function(str) {
  try { atob(str); } catch (e) { return false; }
  return true;
}

global.isJsonString = function(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}